export const MINE = [
  {
    icon: require('@/assets/image/user/tab1-1.png'),
    label: '收藏',
    path: '/my-collection',
  },
  {
    icon: require('@/assets/image/user/tab1-2.png'),
    label: '关注',
    path: '/my-follow',
  },
  // {
  //   icon: require('@/assets/image/user/tab1-3.png'),
  //   label: '创作',
  // },
  {
    icon: require('@/assets/image/user/tab1-4.png'),
    label: '资源',
    path: '/my-resource',
  },
  {
    icon: require('@/assets/image/user/tab1-5.png'),
    label: '课程',
    path: '/my-course',
  },
]

export const FINANCE = [
  {
    icon: require('@/assets/image/user/tab2-1.png'),
    label: '老板查税',
    path: '/lnquire-tax',
  },
  {
    icon: require('@/assets/image/user/tab2-2.png'),
    label: '专家邀约',
    path: '/expert-invitation',
  },
  {
    icon: require('@/assets/image/user/tab2-3.png'),
    label: '兵器库',
    path: '/weapon-library',
  },
  {
    icon: require('@/assets/image/user/tab2-4.png'),
    label: '纳税测算',
    path: '/tax-calculation',
  },
  {
    icon: require('@/assets/image/user/tab2-5.png'),
    label: '员工管理',
    path: '/staff-manage',
  },
]

export const MY_SERVICE_TOOL = [
  {
    icon: require('@/assets/image/user/tab5-1.png'),
    label: '拼团代账',
    path: '/spell-together/activity',
  },
  {
    icon: require('@/assets/image/user/tab5-2.png'),
    label: '权益包',
    path: '/user/equitypackage/list',
  },
  // {
  //   icon: require('@/assets/image/user/tab5-3.png'),
  //   label: '积分商城',
  //   path: '/integral/mall/1',
  // },
  {
    icon: require('@/assets/image/user/tab5-4.png'),
    label: '订单中心',
    path: '/orderCenter/orderCenter',
  },
  {
    icon: require('@/assets/image/user/tab5-5.png'),
    label: '收货地址',
    path: '/address/manage',
  },
  {
    icon: require('@/assets/image/user/tab5-6.png'),
    label: '浏览记录',
    path: '/my-goods',
  },
  {
    icon: require('@/assets/image/user/tab5-7.png'),
    label: '邀请有礼',
    path: '/invite-courteous/home/1',
    auth: 'emptool',
  },
  {
    icon: require('@/assets/image/user/tab5-8.png'),
    label: '助力商城',
    path: '/eventMall/eventMall',
  },
]

export const MY_SERVICE = [
  // {
  //   icon: require('@/assets/image/user/tab3-1.png'),
  //   label: '合同管理',
  //   path: '/contract-management',
  // },
  {
    icon: require('@/assets/image/user/tab3-2.png'),
    label: '企业信息',
    path: '/company-info',
  },
  {
    icon: require('@/assets/image/user/tab3-3.png'),
    label: '服务进度',
    path: '/progress',
  },
  {
    icon: require('@/assets/image/user/tab3-4.png'),
    label: '素材库',
    path: '/material-library',
    auth: ['employee', 'member'],
  },
  {
    icon: require('@/assets/image/user/tab3-5.png'),
    label: '咨询师',
    path: '/service',
    auth: 'customerType',
  },
  {
    icon: require('@/assets/image/icon/icon-help.png'),
    label: '帮助中心',
    path: '/help',
  },
  {
    icon: require('@/assets/image/user/tab3-13.png'),
    label: '助创大使',
    // path: '/help-venture/poster',
    path: '/homePoster/homePoster',
    auth: 'employee',
  },
  {
    icon: require('@/assets/image/user/tab3-14.png'),
    label: '助创素材库',
    path: '/help-venture/resource',
    auth: 'employee',
  },
  {
    icon: require('@/assets/image/user/tab3-6.png'),
    label: '寻找合伙',
    path: '/recruit-alliance',
  },
  {
    icon: require('@/assets/image/user/tab3-12.png'),
    label: '员工商城',
    path: '/integral/mall/2',
    auth: 'employee',
  },
]

export const MY_COLLECTION_TABS = [
  {
    title: '资讯',
    type: 0,
  },
  {
    title: '话题',
    type: 1,
  },
  {
    title: '精品',
    type: 2,
  },
  {
    title: '小视频',
    type: 3,
  },
]

export const MY_RESOURCE_TABS = [
  {
    title: '我发布的',
    type: 0,
  },
  {
    title: '我的收藏',
    type: 1,
  },
]

export const ORDER_LIST_TYPE = [
  {
    title: '全部',
    type: 0,
  },
  {
    title: '待处理',
    type: 1,
  },
  {
    title: '已完成',
    type: 2,
  },
]

export const INTEGRAL_DETAIL_TYPE = [
  {
    title: '积分明细',
    type: 0,
  },
  {
    title: '兑换记录',
    type: 1,
  },
  {
    title: '积分规则',
    type: 2,
  },
]

export const BINDING_LIST_TABS = [
  {
    title: '待审批',
    type: 0,
  },
  {
    title: '已通过',
    type: 1,
  },
  {
    title: '已拒绝',
    type: 2,
  },
]

export const WEAPON_TYPE = [
  {
    title: '股权合同',
    type: 1,
    img: require('@/assets/image/mine/weapon1.png'),
  },
  {
    title: '员工入股',
    type: 2,
    img: require('@/assets/image/mine/weapon2.png'),
  },
  {
    title: '创业协议',
    type: 3,
    img: require('@/assets/image/mine/weapon3.png'),
  },
  {
    title: '公司章程',
    type: 4,
    img: require('@/assets/image/mine/weapon4.png'),
  },
  {
    title: '财务管理',
    type: 5,
    img: require('@/assets/image/mine/weapon5.png'),
  },
  {
    title: '股权分配',
    type: 6,
    img: require('@/assets/image/mine/weapon6.png'),
  },
  {
    title: '投资入股',
    type: 7,
    img: require('@/assets/image/mine/weapon7.png'),
  },
  {
    title: '人力资源',
    type: 8,
    img: require('@/assets/image/mine/weapon8.png'),
  },
  {
    title: '市场营销',
    type: 9,
    img: require('@/assets/image/mine/weapon9.png'),
  },
]

export const WEAPON_TYPE2 = [
  {
    title: '最新',
    type: 0,
  },
  {
    title: '浏览最多',
    type: 1,
    text: 'PAGE_VIEW DESC',
  },
  {
    title: '收藏最多',
    type: 2,
    text: 'COLLECTION DESC',
  },
  {
    title: '下载最多',
    type: 3,
    text: 'DOWNLOADS DESC',
  },
]

export const CONTRACT_MANAGEMENT_TYPE = [
  {
    title: '全部',
    type: 0,
  },
  {
    title: '已签',
    type: 1,
  },
  {
    title: '未签',
    type: 2,
  },
  {
    title: '已付',
    type: 3,
  },
  {
    title: '未付',
    type: 4,
  },
]

export const MESSAGE_LIST = [
  {
    content: {
      title: '商标变更',
      tips: '专业团队办理，服务快捷无忧',
      price: 5250,
    },
    createDate: '星期六 上午  12:13',
    fromType: 1,
    fromUserHeadImg: require('@/assets/image/temp-img/avt.png'),
    fromUserId: 0,
    hintMsg: 0,
    id: 1,
    initiationType: 0,
    msgType: 1,
    name: '',
    realName: '',
    receiveUserHeadImg: '',
    receiveUserId: 2,
  },
  {
    content: '你好，我想咨询代理记账你好',
    createDate: '星期六 上午  12:13',
    fromType: 1,
    fromUserHeadImg: require('@/assets/image/temp-img/avt.png'),
    fromUserId: 0,
    hintMsg: 0,
    id: 1,
    initiationType: 0,
    msgType: 0,
    name: '',
    realName: '',
    receiveUserHeadImg: '',
    receiveUserId: 2,
  },
  {
    content:
      '我是发送者，我想咨询代理记账你好，我想咨询代理记账你好，我想咨询代理记账你好，我想咨询代理记账',
    createDate: '星期六 上午  12:13',
    fromType: 1,
    fromUserHeadImg: require('@/assets/image/temp-img/avt.png'),
    fromUserId: 0,
    hintMsg: 0,
    id: 2,
    initiationType: 0,
    msgType: 0,
    name: '',
    realName: '',
    receiveUserHeadImg: '',
    receiveUserId: 2,
  },
  {
    content: '我是发送者',
    createDate: '',
    fromType: 2,
    fromUserHeadImg: require('@/assets/image/temp-img/avt.png'),
    fromUserId: 0,
    hintMsg: 0,
    id: 3,
    initiationType: 0,
    msgType: 0,
    name: '',
    realName: '',
    receiveUserHeadImg: '',
    receiveUserId: 2,
  },
  {
    content: '我是发送者',
    createDate: '星期六 上午  12:13',
    fromType: 2,
    fromUserHeadImg: require('@/assets/image/temp-img/avt.png'),
    fromUserId: 0,
    hintMsg: 0,
    id: 4,
    initiationType: 0,
    msgType: 0,
    name: '',
    realName: '',
    receiveUserHeadImg: '',
    receiveUserId: 2,
  },
]

export const LNQUIRE_TAX = [
  {
    title: '财务概要表',
    icon: require('@/assets/image/tax/item1.png'),
    path: '/financial-summary',
  },
  {
    title: '利润情况',
    icon: require('@/assets/image/tax/item2.png'),
    path: '/finance/profitState',
  },
  {
    title: '资产负债表',
    icon: require('@/assets/image/tax/item3.png'),
    path: '/finance/assetLiability',
  },
  {
    title: '利润表',
    icon: require('@/assets/image/tax/item4.png'),
    path: '/finance/profitForm',
  },
  {
    title: '应付项目',
    icon: require('@/assets/image/tax/item5.png'),
    path: '/finance/copeWith',
  },
  {
    title: '应收项目',
    icon: require('@/assets/image/tax/item6.png'),
    path: '/finance/copeCollect',
  },
  {
    title: '纳税情况',
    icon: require('@/assets/image/tax/item7.png'),
    path: '/finance/payTaxesState',
  },
]

export const FILE_TYPE = [
  {
    title: '全部',
    type: 0,
  },
  {
    title: 'PPT',
    type: 1,
  },
  {
    title: 'DOC',
    type: 2,
  },
  {
    title: 'XLS',
    type: 3,
  },
  {
    title: 'PDF',
    type: 4,
  },
]

export const EQUITY_PACKAGE_STATE = [
  {
    title: '已使用',
    type: 1,
  },
  {
    title: '已过期',
    type: -1,
  },
]

export const HELP_VENTURE_RESOURCE_TYPE = [
  {
    title: '资讯',
    type: 0,
  },
  {
    title: '小视频',
    type: 0,
  },
  {
    title: '已认领',
    type: 0,
  },
  {
    title: '微信二维码',
    type: 0,
  },
]

export const SPELL_TOEGTHER_TYPE = [
  {
    title: '全部',
    type: null,
  },
  {
    title: '待成团',
    type: 0,
  },
  {
    title: '已成团',
    type: 1,
  },
  {
    title: '已关闭',
    type: 2,
  },
]
